/**
 * Kuwaiti dinar.
 */
export var KWD = {
  code: 'KWD',
  base: 10,
  exponent: 3
};